import React from "react";
import styled from "styled-components";
import { BorderProps, ColorProps, LayoutProps, MarginProps, position } from "styled-system";
import { colorSelector } from "../../utils/ColorSelector";
import { Box } from "../Box";
import { Flex } from "../Flex";

interface Props {
  id?: string;
  iconColor?: string;
  align?: string;
}

const Inner = styled(Flex)`
  ${position}
  & > :first-child {
    margin: ${props => (props.align === "left" ? "0 0" : "0 auto")};
    fill: ${props => colorSelector(props.iconColor)};
  }
`;

export const CircularIcon: React.FC<Props & BorderProps & LayoutProps & ColorProps & MarginProps> = ({
  iconColor,
  align,
  children,
  ...props
}) => (
  <Box borderRadius="50%" border="3px solid" width={120} height={120} {...props}>
    <Inner
      width="50%"
      height="50%"
      top="25%"
      m="0 auto"
      position="relative"
      alignItems="center"
      justifyContent="center"
      iconColor={iconColor}
      align={align}
    >
      {children}
    </Inner>
  </Box>
);

CircularIcon.defaultProps = {
  borderColor: "primary",
};
